<template>
  <div v-if="this.modal" class="container-xl container-fluid p-0">
    <div class="d-flex justify-content-between align-items-center p-0 mb-2">
      <h4
        v-if="this.get_done_text"
        class="neue-roman mt-1 d-flex p-0 align-items-center justify-content-start"
        :class="{
          'color-green': (Number(this.get_done) >= 1 && Number(this.get_done) <= 3) || Number(this.get_done) === 8,
          'color-warning': Number(this.get_done) == -2 || Number(this.get_done) == -3,
          'color-acent': Number(this.get_done) == 0 || (Number(this.get_done) >= 4 && Number(this.get_done) <= 7),
        }"
      >
        <i
          class="item-i mr-1 c28 contain"
          :class="{
            check: (Number(this.get_done) >= 1 && Number(this.get_done) <= 3) || Number(this.get_done) === 8,
            x_red: Number(this.get_done) == -2 || Number(this.get_done) == -3,
            clock: Number(this.get_done) == 0 || (Number(this.get_done) >= 4 && Number(this.get_done) <= 7),
          }"
        ></i>
        {{ this.get_done_text }}
      </h4>
      <div v-else class="loader-div">
        <loading
          :active="this.loader"
          :is-full-page="false"
          :height="20"
          :width="50"
          :loader="'dots'"
          :color="'#008D3E'"
          :opacity="0"
        />
      </div>
      <i class="item-i x_red pointer contain" id="m-ps-1" v-on:click="this.close"></i>
    </div>
    <PayStatusTemplate
      :message="this.getMessage()"
      :get_transact="this.get_transact"
      :get_sum="this.get_sum"
      :get_sum2="this.get_sum2"
      :get_res="this.get_res"
      :get_done="this.get_done"
      :exp_post="this.export_postings"
      :loading="this.loader"
      @getParamsExtTransact="this.getParamsExtTransact"
    >
      <template v-slot:loader>
        <loading
          :active="this.loader"
          :is-full-page="false"
          :height="20"
          :width="50"
          :loader="'dots'"
          :color="'#008D3E'"
          :opacity="0"
        />
      </template>

      <template v-slot:links>
        <ul>
          <li>
            <router-link v-if="this.cmd !== 'emission_custom_curr' && this.cmd !== 'burn_custom_curr'" id="m-ps-2" :to="this.newVA ? '/va/new' : this.repeat_url" class="href" v-on:click="this.close">{{
              $t("components.service.modal.PayStatus.1")
            }}</router-link>
          </li>
          <li>
            <router-link id="m-ps-3" :to="'/history'" class="href" v-on:click="this.close">{{
              $t("components.service.modal.PayStatus.2")
            }}</router-link>
          </li>
          <li v-if="this.newVA">
            <router-link id="m-ps-4" :to="'/va/list'" class="href" v-on:click="this.close">{{
              $t("components.service.modal.PayStatus.11")
            }}</router-link>
          </li>
          <li v-else-if="this.cmd && this.cmd !== 'emission_custom_curr' && this.cmd !== 'burn_custom_curr'">
            <router-link id="m-ps-5" :to="'/keyts/list'" class="href" v-on:click="this.close">{{
              $t("components.service.modal.PayStatus.3")
            }}</router-link>
          </li>
          <li v-if="(this.newVA || this.cmd == 'emission_custom_curr' || this.cmd == 'burn_custom_curr') && this.explorer_link">
            <a 
              id="m-ps-6"
              :href="this.explorer_link"
              class="href"
              :class="this.disabled ? 'opacity-75 c_default' : 'opacity-100'"
              :disabled="this.disabled"
              target="_blank"
              >{{ $t("components.service.modal.PayStatus.12") }}</a
            >
          </li>
          <!-- <li v-if="this.newVA">
            <router-link
              :to="this.disabled ? '' : `/va/code/${this.vaCode}`"
              class="href"
              :class="this.disabled ? 'opacity-75' : 'opacity-100'"
              v-on:click="linkClick"
              >{{ $t("components.service.modal.PayStatus.9") }}</router-link
            >
          </li> -->
          <li v-if="this.newVA">
            <a 
              id="m-ps-7"
              :to="this.disabled ? '' : `/va/list?to_emission=${this.ticker}`"
              class="href"
              :class="this.disabled ? 'opacity-75 c_default' : 'opacity-100'"
              v-on:click="linkClick"
              >{{ $t("components.service.modal.PayStatus.10") }}</a
            >
          </li>
        </ul>
      </template>
    </PayStatusTemplate>
  </div>
  
  <div
    v-if="!this.modal"
    class="rounded16 p16"
    :class="{ 'w-608 bg-light-grey content': !this.isMobile, 'w-100 bg-white card-shadow': this.isMobile }"
  >
    <div v-if="!this.first_load">
      <div class="d-flex justify-content-between align-items-center p-0" :class="{ 'mb24': this.isMobile, 'mb16': !this.isMobile }">
          <h4 class="neue fsp20 lh28 text-black mb-0">
              <span v-if="this.error">
                {{ $t('components.service.PayStatusTemplate.9') }}
              </span>
              <span v-else>
                {{ this.get_done === '0' ? $t("components.service.modal.PayStatus.18") : $t("components.service.modal.PayStatus.17") }}
              </span>
          </h4>
      </div>
      <div class="bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }">
        <PayStatusTemplate
          :message="this.getMessage()"
          :get_transact="this.get_transact"
          :get_sum="this.get_sum"
          :get_sum2="this.get_sum2"
          :get_res="this.get_res"
          :get_done="this.get_done"
          :exp_post="this.export_postings"
          :loading="this.loader"
          :error="this.error"
          :modal="this.modal"
          @getParamsExtTransact="this.getParamsExtTransact"
        >
          <template v-slot:loader>
            <loading
              :active="this.loader"
              :is-full-page="false"
              :height="20"
              :width="50"
              :loader="'dots'"
              :color="'#008D3E'"
              :opacity="0"
            />
          </template>
  
          <template v-slot:links>
            <ul class="list-style-none p-0 d-flex flex-column gap-3" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }">
              <li class="d-flex justify-content-between align-items-center gap-2">
                <div class="neue-roman primary-grey">{{ $t("components.service.modal.PayStatus.13") }}</div>
                <router-link id="m-ps-3" :to="'/history'" class="neue text-decoration-underline color-menu text-end" v-on:click="this.close">
                    {{$t("components.service.modal.PayStatus.2")}}
                </router-link>
              </li>
              <li v-if="newVA" class="d-flex justify-content-between align-items-center gap-2">
                <div class="neue-roman primary-grey">{{ $t("components.service.modal.PayStatus.14") }}</div>
                <router-link 
                    :to="this.disabled ? '' : `/va/new?curr=${this.vaCode}`"
                    :class="this.disabled ? 'primary-grey user-select-none pe-none' : 'color-menu pointer'"
                    class="text-decoration-underline neue text-end"
                    :disabled="this.disabled"
                >
                    {{ $t("components.service.modal.PayStatus.16") }}
                </router-link>
              </li>
              <li v-else-if="$route.query.type == 'payin'" class="d-flex justify-content-between align-items-center gap-2">
                <div class="neue-roman primary-grey">{{ $t("components.service.modal.PayStatus.19") }}</div>
                <router-link 
                    :to="'/keyts/list'"
                    :class="this.disabled ? 'primary-grey user-select-none pe-none' : 'color-menu pointer'"
                    class="text-decoration-underline neue text-end"
                >
                    {{ $t("components.service.modal.PayStatus.3") }}
                </router-link>
              </li>
              
              <li v-if="this.newVA" class="d-flex justify-content-between align-items-center gap-2">
                <div class="neue-roman primary-grey">{{ $t("components.service.modal.PayStatus.15") }}</div>
                <router-link 
                    :to="this.disabled ? '' : `/va/list?to_emission=${this.ticker}`"
                    :class="this.disabled ? 'primary-grey user-select-none pe-none' : 'color-menu pointer'"
                    class="text-decoration-underline neue text-end"
                    :disabled="this.disabled"
                >
                    {{ $t("components.service.modal.PayStatus.10") }}
                </router-link>
              </li>
            </ul>
          </template>
          <template v-slot:buttons>
            <div class="d-flex justify-content-between mt40" :class="{ 'position-fixed px24 py16 start-0 bottom-0 bg-white w-100 border-t': isMobile }">
              <Button
                  @click="$router.push(this.newVA ? '/va/list' : '/keyts/list')"
                  :name="this.newVA ? $t('components.service.modal.PayStatus.11') : $t('components.service.modal.PayStatus.3')"
                  type="btn-outline-warning"
                  class="h56 equal-width mr16"
              />
              <Button 
                  @click="repeatOperation" 
                  :name="$t('components.service.modal.PayStatus.1')" 
                  type="btn-warning" 
                  class="h56 equal-width"
              />
            </div>
          </template>
        </PayStatusTemplate>
      </div>
    </div>
    <loading
      v-else-if="this.first_load && !this.$store.state.loader"
      :active="this.loader"
      :is-full-page="false"
      :height="70"
      :width="70"
      :loader="'spinner'"
      :color="this.metaColor"
      :opacity="0"
    />
</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import Button from "@/components/service/Button";
import PayStatusTemplate from "@/components/service/PayStatusTemplate";
import {
  bodyPayoutCode,
  getPayoutStatusDecision,
  shouldPollPayoutStatus,
} from "@/includes/payoutStatus";

export default {
  components: {
    Loading,
    Button,
    PayStatusTemplate,
  },
  data() {
    return {
      result: this.$store.state.result ? this.$store.state.result.result : this.$store.state.modal?.content?.result,
      result_text: this.getResultText(),
      success: this.$route.query.success,
      repeat_url: "Payin",
      loader: true,
      get_res: false,
      get_sum: false,
      get_sum2: false,
      get_transact: false,
      get_done: "0",
      get_done_text: "",
      export_postings: false,
      timeout: false,
      exp_status: false,
      disabled: true,
      newVA: false,
      explorer_link: "",
      vaCode: '',
      ticker: false,
      cmd: '',
      first_load: true,
      metaColor: process.env.VUE_APP_THEMECOLOR,
      error: false,
    };
  },
  props: {
    close: [Function],
    modal: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isMobile() {
      return this.$store.state.resize.w <= 768;
    },
  },
  methods: {
    getResultText() {
      if (this.$store.state.result) {
        return this.$store.state.result?.advanced?.result_text
          || this.$store.state.result?.result_text
          || ''
      } else {
        return this.$store.state.modal?.content?.advanced?.result_text
          || this.$store.state.modal?.content?.result_text
          || ''
      }
    },
    repeatOperation() {
      if(this.newVA) {
        this.$router.push('/va/new');
      } else {
        if(this.cmd === 'emission_custom_curr') {
          this.$router.push(`/va/list?to_emission=${this.ticker}`);
        } else if(this.cmd === 'burn_custom_curr') {
          this.$router.push(`/va/list?to_burn=${this.ticker}`);
        }
      }
      if(this.$route.query.type == 'payin') {
        this.$router.push('/payin');
      }
    },
    linkClick(event) {
      if (this.disabled) {
        event.preventDefault();
      } else {
        this.close();
      }
    },
    getTitle() {
      if (this.result === "0") {
        return this.$t("components.service.modal.PayStatus.4");
      } else if (this.success !== "0") {
        return this.$t("components.service.modal.PayStatus.5");
      }
    },
    getMessage() {
      if (this.result_text) {
        return this.result_text;
      } else {
        return false;
      }
    },
    copy(text) {
      this.$lib.copyTextS(text, this.$store)
    },
    clearPollTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = false;
      }
    },
    schedulePoll(fn, delayMs = 5000) {
      this.clearPollTimeout();
      this.timeout = setTimeout(fn, delayMs);
    },
    applyPayoutFailure(errorText) {
      this.clearPollTimeout();
      this.loader = false;
      this.first_load = false;
      this.error = true;
      this.get_done = "-2";
      this.get_done_text = "";
      this.get_sum = false;
      this.get_sum2 = false;
      this.get_transact = false;
      const text = (errorText && String(errorText).trim())
        || this.$t("components.service.modal.PayStatus.20");
      this.result_text = text;
      this.get_res = text;
    },
    /**
     * Пока msPayout не создал транзакцию, GetParamsExtTransact всегда
     * отдаёт пустой done=0 («принята в обработку»). Для type=pay сначала
     * опрашиваем GetPayoutStatus: при *:failed показываем ошибку и
     * останавливаемся; только при терминальном успехе переключаемся на прежний
     * GetParamsExtTransact. Наличие transaction не гарантирует успех
     * последующих стадий обработки выплаты.
     */
    pollPayoutStatus() {
      const content = this.$store.state.modal.content
        ? this.$store.state.modal.content
        : this.$store.state.result;
      const code = bodyPayoutCode(content);
      if (!code) {
        this.getParamsExtTransact();
        return;
      }

      this.loader = true;
      this.axios
        .post("GetPayoutStatus", {
          no_loader: true,
          no_error_msg: true,
          data: { code },
        })
        .then((res) => {
          const body = (res.data && res.data.body) || {};
          // Endpoint отсутствует / 4xx → axios error; сюда приходит только
          // HTTP 200. Неизвестный маршрут на backend даёт catch ниже.
          if (res.data && res.data.error) {
            this.getParamsExtTransact();
            return;
          }
          if (body.result != null && body.result !== "0" && body.result !== 0) {
            // Нет доступа / payout не найден — не крутим вечный «успех».
            const failText = typeof body.result_text === "string"
              ? body.result_text.trim()
              : "";
            this.applyPayoutFailure(
              failText || this.$t("components.service.modal.PayStatus.20"),
            );
            return;
          }

          const decision = getPayoutStatusDecision(body);
          if (decision.action === "failed") {
            this.applyPayoutFailure(decision.errorText);
            return;
          }
          if (decision.action === "load_transaction") {
            this.getParamsExtTransact();
            return;
          }

          // processing: держим «В обработке», без суммы 0 как финала.
          this.first_load = false;
          this.error = false;
          this.get_done = "0";
          this.get_res = this.result_text || this.$t("components.service.PayStatusTemplate.7");
          this.loader = true;
          this.schedulePoll(() => this.pollPayoutStatus());
        })
        .catch(() => {
          // GetPayoutStatus ещё не задеплоен — прежний poll по ext_transact.
          this.getParamsExtTransact();
        });
    },
    getParamsExtTransact() {
      const modalExt = this.$store.state.modal?.content?.ext_transact;
      const resultExt = this.$store.state.result?.ext_transact;
      if (!modalExt && !resultExt) {
        return;
      }
      if (this.get_done == "0" && this.modal) {
        this.get_done_text = "";
        this.get_res = false;
      }
      let params = { ext_transact_num: modalExt || resultExt, only_data: "1" };
      this.loader = true;
      this.axios.post("GetParamsExtTransact", { no_loader: true, data: params }).then((res) => {
        this.loader = false;
        // console.log('GETPARAMSEXTTRANSACT: ')
        // console.log(res);
        if (res.data.body.result == "0") {
          this.newVA = res.data.body.advanced.cmd == "create_custom_curr";
          this.cmd = res.data.body.advanced.cmd;
          if (res.data.body.advanced.done == "1") {
            this.disabled = false;
          }
          let shop = [];
          let pay = [];
          res.data.body.tables.forEach((e) => {
            if (e.name == "shop") {
              shop = e;
            }
            if (e.name == "pay") {
              pay = e;
            }
            if (e.name == "export_postings") {
              this.export_postings = e.colvalues.length > 0 ? e.colvalues : false;
            }
          });
          this.get_sum = "";
          if (res.data.body.advanced.id_shop == res.data.body.advanced.id_pay) {
            this.get_sum = pay["colvalues"][0].sum + " " + pay["colvalues"][0].curr_text;
            this.get_sum2 = shop["colvalues"][0].sum + " " + shop["colvalues"][0].curr_text;
          } else {
            if (this.$store.state.userData.id != res.data.body.advanced.id_shop) {
              this.get_sum = pay["colvalues"][0].sum + " " + pay["colvalues"][0].curr_text;
            } else if (this.$store.state.userData.id != res.data.body.advanced.id_pay) {
              this.get_sum = shop["colvalues"][0].sum + " " + shop["colvalues"][0].curr_text;
            }
          }

          this.get_res = res.data.body.advanced.result_text;
          this.get_done = res.data.body.advanced.done;
          this.get_done_text = res.data.body.advanced.done_text;
          this.explorer_link = res.data.body.tables.find(
            (table) => table.name == "export_postings"
          ).colvalues[0]?.explorer_link;
          let shop_table = res.data.body.tables.find(
            (table) => table.name == "shop"
          );
          this.vaCode  = shop_table?.colvalues[0].curr_code;
          this.ticker  = shop_table?.colvalues[0].curr_text;

          if(this.cmd === 'burn_custom_curr') {
            let pay_table = res.data.body.tables.find(
              (table) => table.name == "pay"
            );
            this.vaCode = pay_table?.colvalues[0].curr_code;
            this.ticker = pay_table?.colvalues[0].curr_text;
          }

          this.get_transact = res.data.body.advanced.transact;

          if (this.export_postings) {
            if (this.export_postings.length > 0) {
              this.exp_status = this.export_postings[0]["export_status"];
              if (this.exp_status === "1" || this.exp_status === "13" || this.exp_status === "14") {
                return;
              }
            }
          }
          if (this.get_done !== "0" && (!this.export_postings || this.export_postings.length == 0)) {
            return;
          } else if (
            (this.get_done === "0" && this.exp_status == "0") ||
            this.exp_status !== "1" ||
            this.exp_status !== "13" ||
            this.exp_status !== "14"
          ) {
            // Пока транзакции ещё нет (пустой done=0) и это async payout —
            // возвращаемся к GetPayoutStatus, чтобы поймать *:failed.
            const content = this.$store.state.modal.content
              ? this.$store.state.modal.content
              : this.$store.state.result;
            if (shouldPollPayoutStatus(content) && !this.get_transact) {
              this.schedulePoll(() => this.pollPayoutStatus());
              return;
            }
            this.schedulePoll(() => {
              this.getParamsExtTransact();
            });
          }
        } else {
          this.get_res = res.data.body.result_text;
          this.error = true;
          this.clearPollTimeout();
        }
      }).finally(() => {
        this.first_load = false;
      });
    },
  },
  mounted() {
    const content = this.$store.state.modal.content ? this.$store.state.modal.content : this.$store.state.result;
    if (content) {
      // Set initial values from response advanced data (mstransact)
      if (content.advanced && content.advanced.transact) {
        this.get_transact = String(content.advanced.transact);
        if (content.advanced.sum !== undefined) {
          this.get_sum = String(content.advanced.sum) + (content.advanced.curr_text ? ' ' + content.advanced.curr_text : '');
        }
        this.get_res = content.result_text || '';
        this.get_done = '1';
        this.get_done_text = content.result_text || '';
        this.loader = false;
      }
      if (content.type == "pay") {
        this.repeat_url = "Pay";
      }
      if (content.type == "transfer") {
        this.repeat_url = "transfer_id";
      }
      if (content.type == "transfer_self") {
        this.repeat_url = "transfer_self";
      }
      if(content.cmd) {
        this.cmd = content.cmd;
      }
      if (shouldPollPayoutStatus(content)) {
        this.pollPayoutStatus();
      } else if (content.ext_transact) {
        this.getParamsExtTransact();
      }
    }
    // console.log(this)
  },
  beforeUnmount() {
    this.clearPollTimeout();
  },
};
</script>

<style lang="scss" scoped>
.loader-div {
  position: relative;
  min-height: 20px;
  width: 50px;
  z-index: 2000;
}
.w-608 {
  width: 608px;
}
.h56 {
  height: 56px;
}
.list-style-none {
  list-style: none;
}
.card-shadow {
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.05);
}
</style>
